
import { Node } from "@xyflow/react";

export const NODE_SHAPES = [
  "rectangle",
  "cloud",
  "diamond", 
  "circle",
  "pentagon"
];

export type NodeShape = typeof NODE_SHAPES[number];

// Define shape CSS classes
export const getShapeClassName = (shape: NodeShape): string => {
  switch (shape) {
    case "cloud": return "node-shape-cloud";
    case "diamond": return "node-shape-diamond";
    case "circle": return "node-shape-circle";
    case "pentagon": return "node-shape-pentagon";
    case "rectangle":
    default:
      return "node-shape-rectangle";
  }
};

// Function to apply shape to a node
export const applyNodeShape = (node: Node, shape: NodeShape): Node => {
  return {
    ...node,
    data: {
      ...node.data,
      shape
    }
  };
};
